import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DKGenericPageHeader = _resolveComponent("DKGenericPageHeader")!
  const _component_GenericPageRenderer = _resolveComponent("GenericPageRenderer")!

  return (_ctx.genericPage && _ctx.genericPageId)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_DKGenericPageHeader, {
          ref: "genericHeader",
          genericPage: _ctx.genericPage,
          headerType: _ctx.headerType,
          locale: _ctx.$locale,
          onClickPageNavbarItem: _ctx.onClickPageNavbarItem
        }, null, 8, ["genericPage", "headerType", "locale", "onClickPageNavbarItem"]),
        _createVNode(_component_GenericPageRenderer, { fragments: _ctx.genericPageFragments }, null, 8, ["fragments"])
      ]))
    : _createCommentVNode("", true)
}